module.exports = __webpack_public_path__ + "img/saddle-cloths-8.f0c3129b.svg";